import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  List,
  ListItem,
  makeStyles,
  Typography,
} from '@material-ui/core';
import {ArrowForward, ExpandMore} from '@material-ui/icons';
import React from 'react';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import {Benefit} from '../../models/Policy';

const useBenefitGridStyles = makeStyles(_theme => ({
  benefitTitleLink: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#0033A0',
    width: '100%',
  },
  benefitName: {
    fontWeight: 'bold',
    padding: '4px',
  },
  benefitHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItem: 'center',
    boxShadow: 'none',
  },
  separator: {
    border: '1px solid #ccc',
    width: '100%',
    '&:last-of-type': {
      display: 'none',
    },
  },
}));

type BenefitGridProps = {
  benefitName: string;
};

const BenefitGrid = (props: BenefitGridProps) => {
  const styles = useBenefitGridStyles();
  return (
    <>
      <div className={styles.benefitTitleLink}>
        <Typography className={styles.benefitName}>{props.benefitName}</Typography>
        <ArrowForward />
      </div>
      <hr className={styles.separator} />
    </>
  );
};

const useBenefitAccordionStyles = makeStyles(_theme => ({
  accordionElement: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    boxShadow: '0px 2px 4px 0px #00000044',
  },
  accordionSummary: {
    backgroundColor: '#F4F8FC',
    borderRadius: 0,
  },
  benefitDesc: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#2f3847',
  },
  divider: {
    '&:last-of-type': {
      display: 'none',
    },
  },
  benefitList: {
    width: '100%',
  },
}));

export interface BenefitAccordionProps {
  benefit: Benefit;
  idx: number;
  active: boolean;
  handleBenefitClick: (index: number) => void;
  handleAccordionClick: (index: number) => void;
}

const BenefitAccordion = (props: BenefitAccordionProps) => {
  const {active, benefit, idx, handleAccordionClick, handleBenefitClick} = props;
  const styles = useBenefitAccordionStyles();

  return (
    <Grid item md={12}>
      <Accordion TransitionProps={{unmountOnExit: true}} className={styles.accordionElement} expanded={active}>
        <AccordionSummary
          expandIcon={<ExpandMore style={{color: '#0033A0'}} />}
          aria-controls="panel1a-content"
          id={toKebabCase(benefit.desc)}
          className={styles.accordionSummary}
          onClick={() => handleAccordionClick(idx)}
        >
          <Typography className={styles.benefitDesc}>{benefit.desc}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List className={styles.benefitList}>
            {benefit.details.map(({benefitName}, index) => (
              <React.Fragment key={toKebabCase(benefitName)}>
                <ListItem button onClick={() => handleBenefitClick(index)} id={toKebabCase(benefitName)}>
                  <BenefitGrid benefitName={benefitName} />
                </ListItem>
                <Divider className={styles.divider} />
              </React.Fragment>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default BenefitAccordion;
